import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import roLogo from '../../images/reportonce-logo-white.svg'

import Login from "./Login";
import Register from "./Register";

const useStyles = makeStyles((theme) =>
    createStyles({
        contentWrapper: {
            background: theme.palette.background.default,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            minHeight: "100%",
        },
        loginCard: {
            alignItems: "stretch",
            background: "#fff",
            display: "flex",
            margin: "0 auto",
            flexDirection: "row",
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
            },
        },
        loginMedia: {
            background: theme.palette.secondary.main,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            // alignContent: "center",
            // padding: theme.spacing(10),
            width: '300px',
            [theme.breakpoints.down("sm")]: {
                // padding: theme.spacing(5),
            },
        },
        welcomeMessage: {
            alignSelf: "center",
            color: theme.palette.primary.main,
            width: "min-content",
        },
        loginImg: {
            height: "auto",
            margin: "0 auto",
            maxWidth: "100%",
            width: "185px",
        },
        loginContent: {
            padding: theme.spacing(3, 4),
            position: "relative",
        },
        loginForm: {
            display: "flex",
            flexDirection: "column",
        },
        loginInput: {
            margin: theme.spacing(0, 0, 3),
            minWidth: "200px",
            width: "100%",
        },
        loginButton: {
            margin: theme.spacing(1, 0, 3),
        },
        linkText: {
            color: theme.palette.primary.main,
            textDecoration: "none",
            transition: "color 300ms",
            "&:hover": {
                color: theme.palette.primary.dark,
            },
        },
        poweredBy: {
            margin: theme.spacing(3, 0, 0),
            textAlign: "center",
        },
        loginLoadingOverlay: {
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.6)",
            bottom: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
        },
        signUp: {
            textAlign: "center",
            cursor: "pointer",
            display: "block"
        },
    })
);

export default function User(props) {
    const classes = useStyles();
    const contentMap = {
        "login": <Login classes={classes} />,
        "register": <Register classes={classes} />
    }
    let content = contentMap[props?.type ? props.type : contentMap['login']];

    return (
        <Box className={classes.contentWrapper}>
            <Card className={classes.loginCard}>
                <CardMedia className={classes.loginMedia}>
                    <img src={roLogo} alt="Brand logo" style={{ paddingLeft: "10px" }}/>
                </CardMedia>
                <CardContent className={classes.loginContent}>
                    {content}
                </CardContent>
            </Card>
        </Box>
    );
}
